export default {
  navigationBarTitleText: '查看成片'
};
